import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=bd12720c&scoped=true&"
import script from "./Launcher.vue?vue&type=script&lang=js&"
export * from "./Launcher.vue?vue&type=script&lang=js&"
import style0 from "./Launcher.vue?vue&type=style&index=0&id=bd12720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd12720c",
  null
  
)

export default component.exports